module.exports = "<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/productos/subcategoria-producto/subcategoria-producto.component.html
// module id = ./src/app/productos/subcategoria-producto/subcategoria-producto.component.html
// module chunks = main